import {
  Baby,
  BookOpen,
  Building2,
  CalendarCheck,
  CalendarDays,
  CalendarRange,
  CalendarX2,
  ClipboardCheck,
  ClipboardList,
  GraduationCap,
  HeartHandshake,
  Home,
  Inbox,
  LibraryBig,
  Link2,
  ListChecks,
  MessageSquare,
  NotebookPen,
  School,
  Settings,
  Share2,
  Users,
  UserRound,
  type LucideIcon,
} from 'lucide-react';
import type { NavGroup } from '@/components/shell/nav-model';

export const navigationIconRegistry: Readonly<Record<string, LucideIcon>> = {
  baby: Baby,
  'book-open': BookOpen,
  building: Building2,
  'calendar-check': CalendarCheck,
  'calendar-days': CalendarDays,
  'calendar-range': CalendarRange,
  'calendar-x': CalendarX2,
  'clipboard-check': ClipboardCheck,
  'clipboard-list': ClipboardList,
  'graduation-cap': GraduationCap,
  'heart-handshake': HeartHandshake,
  home: Home,
  inbox: Inbox,
  library: LibraryBig,
  link: Link2,
  'list-checks': ListChecks,
  'message-square': MessageSquare,
  'notebook-pen': NotebookPen,
  school: School,
  settings: Settings,
  share: Share2,
  users: Users,
  'user-round': UserRound,
};

export const navigationGroupRegistry: Readonly<Record<string, NavGroup>> = {
  teaching: '教学',
  management: '管理',
  collaboration: '协作',
  personal: '我的',
  setup: '教务设置',
};
